import React from 'react';

const RefundPolicy = () => {
  return (
    <div className="min-h-screen bg-white py-12 px-4">
      <div className="max-w-4xl mx-auto">
        <h1 className="text-4xl font-bold mb-8 text-gray-900">Refund Policy</h1>
        <p className="text-sm text-gray-500 mb-8">Last updated: January 2025</p>

        <div className="space-y-8 text-gray-700">
          <section>
            <h2 className="text-2xl font-semibold mb-4 text-gray-900">1. Overview</h2>
            <p>
              TESTBOOK LTD is committed to providing excellent customer service. This Refund Policy outlines the circumstances under which refunds are provided for driving test bookings made through our service.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4 text-gray-900">2. Cancellation and Refund Eligibility</h2>
            <p className="mb-4">You may be eligible for a refund in the following circumstances:</p>
            <ul className="list-disc pl-6 space-y-2">
              <li><strong>Cancellation with 14 days notice:</strong> Full refund minus £10 administrative fee</li>
              <li><strong>Cancellation between 7-14 days:</strong> 50% refund of the booking fee</li>
              <li><strong>Cancellation within 7 days:</strong> No refund available</li>
              <li><strong>Service error:</strong> Full refund if we cannot provide the service as promised</li>
              <li><strong>Double booking:</strong> Full refund if booking was made in error</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4 text-gray-900">3. Non-Refundable Circumstances</h2>
            <p className="mb-4">Refunds will not be provided in the following situations:</p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Failure to attend your scheduled test without prior cancellation</li>
              <li>Late arrival to your test appointment</li>
              <li>Cancellations made less than 7 days before the test date</li>
              <li>Test failure or not meeting test requirements</li>
              <li>Change of mind after the 14-day cooling-off period</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4 text-gray-900">4. DVSA Cancellation Policy</h2>
            <p>
              Please note that driving tests booked through the official DVSA system are also subject to DVSA's own cancellation and refund policies. We recommend reviewing the DVSA terms before making a booking.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4 text-gray-900">5. How to Request a Refund</h2>
            <p className="mb-4">To request a refund, please:</p>
            <ol className="list-decimal pl-6 space-y-2">
              <li>Contact us via email at info@testbook.co.uk with your booking reference</li>
              <li>Provide the reason for your refund request</li>
              <li>Allow up to 10 business days for your refund to be processed</li>
              <li>Refunds will be issued to the original payment method</li>
            </ol>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4 text-gray-900">6. Processing Time</h2>
            <p>
              Once a refund is approved, it will typically take:
            </p>
            <ul className="list-disc pl-6 space-y-2 mt-4">
              <li>3-5 business days for the refund to appear in your bank account (debit/credit cards)</li>
              <li>5-10 business days for bank transfers</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4 text-gray-900">7. Rescheduling vs. Cancellation</h2>
            <p>
              If you need to change your test date rather than cancel completely, we recommend rescheduling instead. Rescheduling may incur a smaller fee than full cancellation depending on the timing:
            </p>
            <ul className="list-disc pl-6 space-y-2 mt-4">
              <li><strong>More than 14 days notice:</strong> Free rescheduling</li>
              <li><strong>7-14 days notice:</strong> £15 rescheduling fee</li>
              <li><strong>Less than 7 days:</strong> £30 rescheduling fee (subject to availability)</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4 text-gray-900">8. Exceptional Circumstances</h2>
            <p>
              We understand that unexpected situations can arise. In cases of medical emergencies, bereavement, or other exceptional circumstances, please contact us directly. We will review your case individually and may offer special consideration.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4 text-gray-900">9. Disputes</h2>
            <p>
              If you are not satisfied with our refund decision, you may escalate your complaint by contacting our customer service team. We aim to resolve all disputes fairly and promptly.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4 text-gray-900">10. Contact Information</h2>
            <p className="mb-4">
              For refund inquiries or to request a cancellation:
            </p>
            <p>
              TESTBOOK LTD<br />
              20 Wenlock Road, London, England, N1 7GU<br />
              Email: info@testbook.co.uk<br />
              Company Number: 16836503
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4 text-gray-900">11. Changes to This Policy</h2>
            <p>
              TESTBOOK LTD reserves the right to modify this Refund Policy at any time. Changes will be posted on this page with an updated revision date.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default RefundPolicy;